var exports = {
  "q": "AppLayout.module__appLayout___WmxCRG",
  "X": "AppLayout.module__appLayoutStandalone___WmxCRG",
};

module.exports = exports;
